<template>
  <div class="z-border-red" style="margin-bottom: 10px;">
    <v-layout>
      <v-flex>
        <div class="ma-2">
          <v-checkbox
            :input-value="isCheck"
            :label="`Order No. ${order.id}`"
            style="display: inline-block;margin: 0;"
            @change="assignCb(order.id)"
            color="primary"
          ></v-checkbox>
        </div>
      </v-flex>
      <v-flex>
        <div class="ma-2 text-xs-right">
          <template v-if="order.app == 'facebook'">
            <i class="fab fa-facebook-square" style="color: #3C5A99"></i>
          </template>
          <template v-else-if="order.app == 'line'">
            <i class="fab fa-line" style="color: #00c300"></i>
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm7>
        <div style="border-right: 1px solid #eee; height: 100%">
          <template v-if="typeof orderDetailFormat == 'string'">
            <div class="pa-2">
              <nl2br tag="div" :text="order.productdetail"></nl2br>
            </div>
          </template>
          <template v-else-if="typeof orderDetailFormat == 'object'">
            <template v-for="(order, oindex) in orderDetailFormat">
              <v-layout wrap :key="'order_' + oindex">
                <v-flex sm1 xs2>
                  <div class="ma-2">
                    <v-img :src="order.photourl" aspect-ratio="1" alt class="grey lighten-2">
                      <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                        </v-layout>
                      </template>
                    </v-img>
                  </div>
                </v-flex>
                <v-flex sm7 xs6 style="word-break: break-word;">
                  <div class="ma-2">
                    {{ order.name }} x {{ order.quantity }}
                    <template v-if="order.option">({{ order.option }})</template>
                  </div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <div class="ma-2">${{ order.price | decimalFormat }}</div>
                </v-flex>
              </v-layout>
              <v-divider v-if="oindex < orderDetailFormat.length - 1" :key="oindex"></v-divider>
            </template>
          </template>

          <div>
            <v-layout v-if="order.total != null && order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Subtotal') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">${{ order.total | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Discount') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">-${{ order.discount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('Total') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">${{ order.amount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-divider />

          <v-layout>
            <v-flex class="pa-2">
              <div class="caption">
                <template v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  >หมายเลขเดอะวัน</template
                >
                <template v-else>{{ $t('Remark') }}</template>
              </div>
              <editable
                v-model="order.remark"
                :filter="'text'"
                :type="'text'"
                @edited="$emit('updateOrder', { type: 'save', order })"
              ></editable>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div style="word-break: break-word;" class="pa-2">
          <a target="_BLANK" :href="`https://business.facebook.com${order.inboxurl}`"
            >{{ order.first_name }} {{ order.last_name }}</a
          >

          <template
            v-if="
              selectedBot.pageid == '103012211224246' ||
                selectedBot.pageid == '635426456938760' ||
                selectedBot.pageid == '613259679129221' ||
                selectedBot.pageid == '101857778024677'
            "
          >
            <template v-if="typeof shippingAddressPosition == 'string'">
              <editable
                v-model="order.nameaddress"
                :type="'textarea'"
                :hasCopy="true"
                @edited="$emit('updateOrder', { type: 'save', order })"
              ></editable>
            </template>
            <template v-else>
              <a
                :href="
                  `https://maps.google.com?q=${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                "
                target="_blank"
                style="word-break: break-word;"
              >
                https://maps.google.com?q={{
                  `${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                }}
              </a>
            </template>
          </template>
          <template v-else>
            <editable
              v-model="order.nameaddress"
              :type="'textarea'"
              @edited="$emit('updateOrder', { type: 'save', order })"
              :hasCopy="true"
            ></editable>
          </template>
          <div class="caption mt-3">{{ $t('Status') }}</div>
          <div class="primary--text">{{ order.userstatus ? order.userstatus : '-' }}</div>
          <template v-if="$store.state.centralPage.includes(selectedBot.pageid)">
            <div class="caption mt-3">{{ $t('Live name') }}</div>
            <div class="primary--text">{{ order.livename ? order.livename : '-' }}</div>
          </template>
          <div class="caption mt-3">{{ $t('Tag') }}</div>
          <template v-if="tags.length > 0">
            <v-chip
              small
              v-for="(tag, index) in tags"
              :key="'tag_' + index"
              outline
              color="primary"
              disabled
              >{{ tag }}</v-chip
            >
          </template>
          <template v-else>
            <div class="primary--text">-</div>
          </template>
        </div>
        <v-divider></v-divider>

        <div class="pa-2">
          <multiselect
            v-model="status"
            :options="orderStatusOptions"
            label="label"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            track-by="label"
            @select="onSelectOrderStatus"
          ></multiselect>

          <template v-if="order.status == 'shipped'">
            <div class="form-control pt-2">
              <textarea
                type="text"
                v-model="order.trackingno"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                @click="$emit('updateOrder', { type: 'send', order })"
                :disabled="
                  order.trackingno == null ||
                    order.trackingno == '' ||
                    order.trackingno.trim() == ''
                "
              >
                <i class="far fa-share-square"></i>
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else-if="order.status == 'canceled'">
            <div class="form-control pt-2">
              <input
                type="text"
                v-model="order.reason"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                @click="$emit('updateOrder', { type: 'save', order })"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <i class="far fa-save"></i>
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                @click="$emit('updateOrder', { type: 'send', order })"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <i class="far fa-share-square"></i>
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else>{{ order.trackingno }}</template>
        </div>
      </v-flex>
    </v-layout>
    <template v-if="order.note">
      <div class="hr"></div>
      <a href="javascript:void(0);" @click="showDetail = !showDetail" style="text-decoration: none">
        <div class="text-xs-center" style="margin: 10px auto">
          {{ $t('Click to view slip') }}
          <i
            class="fas"
            :class="{ 'fa-chevron-down': showDetail, 'fa-chevron-up': !showDetail }"
          ></i>
        </div>
      </a>
      <div
        v-show="showDetail"
        style="margin-bottom: 0;background: rgb(253, 253, 253);border-bottom-left-radius: 10px;"
      >
        <editable
          v-model="order.note"
          :filter="'image'"
          :type="'image'"
          @edited="$emit('updateOrder', { type: 'save', order })"
        ></editable>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './OrderSummaryItem.js'
export default {
  mixins: [mixin]
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ForexSummaryItem.vue